// Basic sanitizer placeholder. In production, replace with a robust library (e.g., DOMPurify or sanitize-html)
// configured to preserve <embed> and <deal> tags. For now, this is a passthrough to keep the contract in place.
export function sanitizeHtml(input: string): string {
  if (!input) return '';
  return input;
}
